import { render, staticRenderFns } from "./batchEditGoods.vue?vue&type=template&id=846137d4&scoped=true&"
import script from "./batchEditGoods.vue?vue&type=script&lang=js&"
export * from "./batchEditGoods.vue?vue&type=script&lang=js&"
import style0 from "./batchEditGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./batchEditGoods.vue?vue&type=style&index=1&id=846137d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846137d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('846137d4')) {
      api.createRecord('846137d4', component.options)
    } else {
      api.reload('846137d4', component.options)
    }
    module.hot.accept("./batchEditGoods.vue?vue&type=template&id=846137d4&scoped=true&", function () {
      api.rerender('846137d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoods/batchEditGoods.vue"
export default component.exports